"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is how you get Checkbox if you don"t pass any props. ' +
    'Just a clickable checker.';
var code = "import React from 'react';\nimport { Checkbox } from 'jsc-react-ui';\n\nconst CheckboxExample = () => <Checkbox />;";
exports.RawExampleCheckbox = function (props) { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.Checkbox, null))); };
exports.RawExampleCheckbox.displayName = 'RawExampleCheckbox';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCheckboxPage/RawExampleCheckbox.tsx
// module id = 648
// module chunks = 0